import React from "react";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import { InputContainer } from "./style";

function InputRange(props) {
  return (
    <InputContainer>
      <Slider tooltip={false} {...props} />
    </InputContainer>
  );
}

export default InputRange;
